import { useMemo } from 'react';

import { EDealersTypesCode } from '@/components/Shared/constants/dicts-codes';
import { DictTypes } from '@/constants';
import { isDictHasAll } from '@/services/helpers/dict';
import { useAppSelector } from '@/store';

const useCheckDealerForLeasing = () => {
  const { dicts } = useAppSelector((state) => state.dict);
  const { dealer } = useAppSelector((state) => state.userInfo);

  const checkDealerForLeasing = (dealerUuid: string): boolean => {
    if (
      !dealerUuid ||
      !isDictHasAll(dicts, [
        DictTypes.Dealers,
        DictTypes.DealersTypes,
        DictTypes.LeasingIndividualsSettings
      ])
    )
      return false;

    const dictDealer = dicts[DictTypes.Dealers].getBy.uuid[dealerUuid];

    if (!dictDealer) return false;

    const dealerTypeUuid = dictDealer.dealer_type_uuid;

    if (!dealerTypeUuid) return false;

    const dictDealerType =
      dicts[DictTypes.DealersTypes].getBy.uuid[dealerTypeUuid];

    if (!dictDealerType || dictDealerType.code === EDealersTypesCode.TRC)
      return false;

    return dicts[DictTypes.LeasingIndividualsSettings].content.some(
      (link) => link.is_active && link.dealer_uuid === dictDealer.uuid
    );
  };

  const isCurrentDealerAvailableForLeasing: boolean = useMemo(() => {
    return checkDealerForLeasing(dealer?.value ?? '');
  }, [dicts, dealer]);

  return {
    checkDealerForLeasing,
    isCurrentDealerAvailableForLeasing,
    currentDealerName: dealer?.label
  };
};

export default useCheckDealerForLeasing;
